// extracted by mini-css-extract-plugin
export var statItem = "_kf-1";
export var statsRow = "_kf-0";